// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__J3RmW","name":"styles_name__1Z5pU","phone":"styles_phone__277j7"};